function getMetaContent(name) {
  const meta = document.head.querySelector(`meta[name='${name}']`);

  if (!meta) {
    return null;
  }

  return meta.getAttribute('content');
}

export default {
  getMetaContent,
};
